import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: import.meta.env.VITE_BASE_API || '/api',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从 auth 工具获取 token
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码不是 200，则认为是错误
    if (res.code !== 200) {
      ElMessage.error(res.msg || '请求失败')

      // 401: 未授权，跳转到登录页（管理端页面回管理登录页，其余回考生登录页）
      if (res.code === 401) {
        localStorage.removeItem('exam_token')
        window.location.href = window.location.pathname.startsWith('/manage')
          ? '/manage/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search)
          : '/exam/login'
      }

      return Promise.reject(new Error(res.msg || '请求失败'))
    }

    return res
  },
  error => {
    console.error('响应错误:', error)

    let message = '网络错误'
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '未授权，请重新登录'
          localStorage.removeItem('exam_token')
          window.location.href = window.location.pathname.startsWith('/manage')
            ? '/manage/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search)
            : '/exam/login'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 500:
          message = '服务器错误'
          break
        default:
          message = error.response.data?.msg || '请求失败'
      }
    }
    
    ElMessage.error(message)
    return Promise.reject(error)
  }
)

export default service
